import ProductsSlider from 'components/Blocks/Product/ProductsSlider';
import useTranslation from 'next-translate/useTranslation';
import { SliderProductItemType } from 'types/product';

type ProductDetailSparePartsProps = {
    spareParts: SliderProductItemType[];
};

const ProductDetailSpareParts: FC<ProductDetailSparePartsProps> = ({ spareParts }) => {
    const { t } = useTranslation();

    if (spareParts.length === 0) {
        return null;
    }

    return (
        <>
            <h2 className="hidden vl:block">
                {t('Spare parts')} ({spareParts.length})
            </h2>
            <ProductsSlider gtmListName="detail spare parts" idSuffix="-spare-parts" products={spareParts} />
        </>
    );
};

export default ProductDetailSpareParts;
